import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FireflyDropdownComponent } from '../dropdown/dropdown.component';

@Component({
  selector: 'f-split-dropdown',
  templateUrl: './split-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireflySplitDropdownComponent extends FireflyDropdownComponent {
  @Input() dropdownButtonTitle?: string;
  @Input() dropdownToggleTitle?: string;
  @Input() loading: boolean = false;
  @Output() buttonClick = new EventEmitter();

  isDropdownOpen = false;

  get isTopPlacement(): boolean {
    return (this.placement ?? '')
      .split(' ')
      .some(token => token === 'top' || token === 'top-left' || token === 'top-right');
  }

  onSplitToggleChange(isOpen: boolean): void {
    this.isDropdownOpen = isOpen;
    this.cdr.markForCheck();
  }
}
